import { render, staticRenderFns } from "./indexcopy.vue?vue&type=template&id=5a0c9215&scoped=true&"
import script from "./indexcopy.vue?vue&type=script&lang=js&"
export * from "./indexcopy.vue?vue&type=script&lang=js&"
import style0 from "./indexcopy.vue?vue&type=style&index=0&id=5a0c9215&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0c9215",
  null
  
)

export default component.exports